export const zh = {
    "k_22d6cfe": "登录渠道1",
    "k_4d1f6fb4": "登录渠道2",
    "k_986bcb6a": "登录渠道加载失败",
    "k_b743f51": "自定义登录配置加载失败",
    "k_2e27262e": "自定义登录样式加载失败",
    "k_6a5eef72": "请联系管理员配置登录渠道",
    "k_4bdd3c94": "选择登录方式",
    "k_d8a2afad": "无极",
    "k_a2eac71e": "专业，全生命周期的管理端低代码平台",
    "k_935f4bcc": "登录",
    "k_931cd808": "请输入用户名",
    "k_f9af73b3": "请输入密码",
    "k_77d58b75": "请同意用户协议",
    "k_ab53e77a": "登录失败:",
    "k_b0321ecc": "登录失败",
    "k_6664897a": "请输入正确的用户名",
    "k_97d3e75b": "已仔细阅读并同意无极服务协议",
    "k_e8bd218c": "无极服务协议",
    "k_f5ec7cec": "请输入手机号",
    "k_ebfdfa99": "输入验证码",
    "k_e3f55d08": "{arg_0}秒后再试",
    "k_a86afcf5": "获取验证码",
    "k_41650cc3": "请输入正确的手机号",
    "k_ac0083bc": "请输入验证码",
    "k_3aaec643": "验证码发送失败:",
    "k_12dad240": "验证码发送失败",
    "k_14abdbea": "验证码填写错误",
    "k_7242a33a": "没有配置图形验证码",
    "k_ce849ee7": "图形验证码加载失败，{arg_0}",
    "k_5288d5b2": "欢迎您使用无极管理台搭建服务！",
    "k_2d2dbb9a": "本协议是腾讯云计算（北京）有限责任公司（以下简称“腾讯”）与您，就您使用无极管理台搭建服务（以下简称“无极服务”）的相关事项签订的合同。为使用无极服务，您应当充分阅读、理解本协议，其中限制、免责条款或者其他涉及您重大权益的条款（如违约处罚、争议管辖等）可能会以加粗、加下划线等形式提示您重点注意。",
    "k_9261642": "除非您已充分阅读、理解并同意接受和遵守本协议，否则，请您不要使用无极服务。您通过网页确认或以其他任何方式明示或者默示表示接受本协议，或您以任何方式使用无极服务的，即视为您已阅读并同意接受本协议的约束，本协议即在您与腾讯之间产生法律效力。",
    "k_b82802dc": "使用无极服务应当遵守本协议及其服务规则。服务规则以无极官网或其他相关页面展示的内容为准，您应事先了解服务规则，并根据服务规则进行操作，以确保顺利使用。",
    "k_c7f00bd": "第一条 通则",
    "k_cb35f80c": "1.1 无极服务指腾讯提供的通过单一平台，即可实现管理台搭建，管理台开发，管理台后期维护各类复杂组合场景的能力，具体包括可视化布局、数据源管理、组件管理、全生命周期管理、API接口能力等模块，具体以产品界面实际展示、提供为准。",
    "k_f2bcf51d": "1.2 涉及具体服务的服务内容、服务等级、技术规范、操作文档、计费标准等内容的服务条款、规则、说明、标准等（统称为“服务规则”），以无极官网或其他相关页面展示的内容为准。",
    "k_aea217a6": "1.3 腾讯是中立的技术服务提供者，依约向您提供各类技术产品和服务；您的网站、应用、软件、平台等任何产品、服务及相关内容等，由您自行运营并承担全部责任。",
    "k_79a3adcb": "1.4 双方均保证已经依照国家相关规定获得了合法经营资质或政府审批等，有权依法运营其产品及服务。双方进一步保证，在本协议有效期内持续保持具备国家相关规定要求的经营资质或审批手续。",
    "k_729e4a80": "第二条 账号",
    "k_4e6f19ee": "2.1 您应依法具备必要、适当的权利能力和行为能力，按照腾讯的要求完成注册、获得无极服务账号（以下简称“账号”）。",
    "k_f322906d": "2.2 为保护账号的安全性和独立性，避免出现账号归属不清晰等不良后果，您应当使用您享有合法权益的微信号、QQ 号、邮箱、微信公众号或手机号等进行注册或登录，否则，可能导致您无法正常登录和使用无极服务。（您在使用以上信息进行账号注册时，如包含有个人信息，您同意腾讯使用签署信息用于为您提供服务）",
    "k_b72423e9": "2.3 您应当按照无极服务流程填写、提交真实、合法、有效的资料（统称“客户资料”），包括但不限于名称、联系人、电子邮箱、联系电话、联系地址、工商登记证件等；如果客户资料发生变更的，您应及时书面通知腾讯或根据无极的规则自行进行更新。",
    "k_76df0969": "2.4 本协议效力适用于您名下全部账号。账号将作为您使用无极服务的身份识别依据，您应当对用户名、密码等信息采取必要、有效的保密和安全保护措施（包括但不限于：保管使用权限、设置高强度密码和定期更换措施等），否则，导致的后果由您自行承担。此外，您应为账号下的行为负责，所有账号下的操作行为均被视为您实施，且应由您承担全部法律后果。",
    "k_d401ddd2": "2.5 您需自行建立健全内部管理制度，规范对账号的使用与管理。为保障您的权益，账号应仅供您自行使用，若您基于自身经营需要等原因，将账号授权您的员工或他人管理的，须做好权限管控，并且在遇到人员变动时及时完成交接和账号安全保护（例如修改密码、变更登录方式、设置账号保护等）。",
    "k_18b32eb5": "2.6 为保护账号和业务等的安全，您应依照国家相关规定及腾讯流程、制度进行实名认证。您同意授权腾讯通过第三方核实您提交的相关信息或资料。",
    "k_d8693568": "2.7 实名认证是对账号归属以及责任承担等进行判断的依据，在发生账号归属争议等纠纷时，腾讯有权认定该账号归属于实名认证主体；对于归属存在争议的账号，腾讯有权暂时对该账号进行冻结。您在进行认证时务必谨慎对待，给与足够的重视并确保认证主体与账号使用主体保持一致，避免将企业使用的账号认证在个人名下，或将本人使用的账号认证在他人名下等任何不当认证行为。",
    "k_f0cdd048": "2.8 若您发现有他人盗用您的账号及密码、或任何其他未经您合法授权的情形时，您应立即以有效方式通知腾讯并提供必要资料（如客户资料、情况说明、证明材料及诉求等，以便腾讯核实身份及事件）。腾讯收到您的有效通知并核实身份后，会依据法律法规及服务规则进行处理。腾讯依据本条进行处理产生的相关责任和后果由您承担。",
    "k_7d48fdba": "若您提供的资料存在瑕疵，导致腾讯无法核实您的身份或无法判断您的需求等，而导致腾讯未能及时处理，给您带来的损失，应由您自行承担。同时，您理解，腾讯对您的请求进行处理需要合理期限，对于腾讯采取措施前您已经产生的损失以及采取措施后因不可归责于腾讯的原因导致的损失，腾讯不承担任何责任。",
    "k_70124226": "第三条 服务",
    "k_7a4e0575": "3.1 服务开通",
    "k_b86f23c2": "您完成账号注册及认证后，腾讯将根据双方商议结果，决定是否为您开通账号的无极服务使用权限，如决定向您开通服务，将会向您予以通知（包括但不限于邮件、短信、电话等）；如决定不向您开通服务，则不会另行通知。",
    "k_7420bcdb": "3.2 服务费用",
    "k_80f942fb": "3.2.1 无极服务暂不向您收取费用，如后续就费用收取发生变化的，将会提前7日向您发送相应通知，如您继续使用服务，则应按照通知支付相应的费用；如您不再使用服务，您应在免费服务期内完成相应的数据迁移等工作，本协议终止。",
    "k_5f9421a8": "3.3 服务支持",
    "k_bf22d63e": "3.3.1 腾讯协助您解答、处理使用无极服务过程中遇到的问题。",
    "k_d78ce8dc": "3.3.2 腾讯将依照法律法规要求对其系统、设备等采取基础的安全保护措施。若您对安全保护措施的要求高于前述基础的安全保护措施标准的，您有权根据自身需求购买配置更高的安全保护服务或另行配置其他安全防护软件、系统等。",
    "k_dda65cab": "3.3.3 您应自行对您使用的计算机信息系统、设备等采取必要的、有效的安全保护措施，因您未采取前述措施导致权益受损的，由您自行承担责任。",
    "k_9c7c4188": "3.3.4 腾讯在您使用过程中，尽力保证服务的可用性进行保证，但不对可用性的高低进行承诺。",
    "k_ee567bc6": "3.4 服务中止或终止",
    "k_f2dc6f6a": "3.4.1 为了向您提供更加完善的服务，腾讯有权定期或不定期地对服务平台或相关设备、系统、软件等进行检修、维护、升级及优化等（统称“常规维护”），如因常规维护造成无极服务在合理时间内中断或暂停的，腾讯无需为此向您承担责任。",
    "k_1ed72911": "3.4.2 为保证服务的安全性和稳定性，腾讯可能进行机房迁移、设备更换等重大调整，前述情况可能导致无极服务在合理时间内中断或暂停，腾讯无需为此向您承担责任。",
    "k_a28e67f2": "3.4.3 如您购买的具体服务含有存储功能的，在该服务到期或终止后，对于您存储在该服务中的数据等任何信息，腾讯将根据该服务的服务规则为您保留相应期限。您应承担保留期限内产生的费用（若有），并按时结清费用、完成全部数据的迁移。保留期限届满后，您的前述信息将被删除。",
    "k_e6a17531": "3.4.4 腾讯有权根据自身运营安排，随时调整、终止部分或全部服务（包括但不限于对服务进行下线、迭代、整合等）。",
    "k_79157a55": "3.5 基于网络服务的及时性、复杂性、高效性等特性及监管要求、政策调整等原因，您同意腾讯可以不时对本协议以及腾讯的相关服务规则进行调整，并通过网站公告、邮件通知、短信通知、系统消息、站内信等方式中的一种或多种予以公布；若您在调整后继续使用腾讯服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的内容。",
    "k_b984443a": "3.6 若您选择使用中国大陆以外的服务，应当确保您符合中国大陆法律法规、政策等的要求，同时，也应当确保您的资质、能力以及使用行为等均符合当地法律法规、政策等的要求。",
    "k_62c11d48": "3.7 第三方产品或服务",
    "k_7ddf746b": "3.7.1 如果您通过腾讯平台获取、使用第三方提供的任何产品或服务（包括但不限于无极服务市场中由服务商等第三方提供的产品、服务），您应当自行评估该产品或服务是否符合您要求。",
    "k_3fc24ca0": "3.7.2 第三方产品或服务的开通，可能需要您与第三方另行签订单独的协议，单独的协议可能以电子文档形式展示，也可能是独立的纸质文档，您可以根据自身情况决定是否接受协议及使用产品或服务。",
    "k_c60bd685": "3.7.3 您因使用第三方产品或服务产生的纠纷由您与第三方自行解决。",
    "k_cc3fd5b3": "第四条 客户权利义务",
    "k_79e254c0": "4.1 您有权依照本协议约定使用无极服务并获得腾讯的技术支持和服务。",
    "k_f1370ba0": "4.2 您在使用腾讯平台上的服务时须遵守相关法律法规及服务规则，并确保拥有法律法规要求的经营资质和能力，不得实施包括但不限于以下行为，也不得为任何违反法律法规的行为提供便利：",
    "k_bb2d6dc8": "4.2.1 反对宪法所规定的基本原则的。",
    "k_b0f46074": "4.2.2 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的。",
    "k_44aad350": "4.2.3 损害国家荣誉和利益的。",
    "k_745fd192": "4.2.4 煽动民族仇恨、民族歧视，破坏民族团结的。",
    "k_2c376120": "4.2.5 破坏国家宗教政策，宣扬邪教和封建迷信的。",
    "k_6e8fb152": "4.2.6 散布谣言，扰乱社会秩序，破坏社会稳定的。",
    "k_dfd776b4": "4.2.7 散布淫秽、色情、赌博、暴力、凶杀、恐怖或教唆犯罪的。",
    "k_ad8092ee": "4.2.8 侮辱或诽谤他人，侵害他人合法权益的。",
    "k_af68bd46": "4.2.9 实施任何违背“七条底线”的行为。",
    "k_99a95427": "4.2.10 含有法律、行政法规禁止的其他内容的。",
    "k_74bcd1c2": "4.3 您在使用腾讯平台上的服务时须维护互联网秩序和安全，不得侵犯任何主体的合法权益，不得实施包括但不限于以下行为，也不得为其提供便利：",
    "k_33043343": "4.3.1 实施诈欺、虚伪不实或误导行为，或实施侵害他人知识产权等任何合法权益的行为，如“私服”、“外挂”等。",
    "k_36ddb916": "4.3.2 发布、传播垃圾邮件（SPAM）或包含危害国家秩序和安全、封建迷信、淫秽、色情、低俗等违法违规信息。",
    "k_a8dce9bf": "4.3.3 违反与腾讯网络相联通之网络、设备或服务的操作规定；实施违法或未授权之接取、盗用、干扰或监测。",
    "k_61a43760": "4.3.4 实施任何破坏或试图破坏网络安全的行为，包括但不限于以病毒、木马、恶意代码、钓鱼等方式，对网站、服务器进行恶意扫描、非法侵入系统、非法获取数据等。",
    "k_c129e918": "4.3.5 实施任何改变或试图改变无极服务提供的系统配置或破坏系统安全的行为；利用技术或其他手段破坏、扰乱无极服务的运营或他人对无极服务的使用；以任何方式干扰或企图干扰腾讯任何产品或任何部分、功能的正常运行，或者制作、发布、传播上述工具、方法等。",
    "k_1017aa27": "4.3.6 因从事包括但不限于“DNS 解析”、“安全服务”、“域名代理”、“反向代理”等任何业务，导致您自己频繁遭受攻击（包括但不限于 DDoS 攻击）且未及时更正行为，或未根据腾讯要求消除影响，从而对无极服务平台或他人产生影响的。",
    "k_b3e9f42b": "4.3.7 实施其他破坏互联网秩序和安全的行为。",
    "k_58daf5cc": "第五条 腾讯权利义务",
    "k_3af60431": "5.1 腾讯应当依照本协议约定向您提供无极服务和支持。",
    "k_b1d1a6e2": "5.2 腾讯仅对无极服务本身提供运营维护，您应当保证自身的网络、设备的安全性、稳定性，如发生以下情况，您应及时解决并避免对无极服务产生影响：",
    "k_bad2655b": "5.2.1 您内部网络出现问题，包括但不限于超负荷等。",
    "k_259095d6": "5.2.2 您自有设备或您使用的第三方设备出现故障。",
    "k_971a9d67": "5.2.3 您自行拆离设备或通过其他方式导致网络中断。",
    "k_9a817baa": "5.2.4 其他您自身原因导致的任何故障、网络中断等。",
    "k_b4e1d6a4": "5.3 若腾讯自行发现或根据相关部门的信息、权利人的投诉等发现您可能存在违反相关法律法规或本协议的行为的，腾讯有权根据一般人的认识自行独立判断，并随时单方采取以下措施中的一种或多种：",
    "k_a985442": "5.3.1 要求您立即删除、修改相关内容。",
    "k_5316e4c6": "5.3.2 限制、暂停向您提供全部或部分无极服务（包括但不限于直接对您的部分服务进行下线并收回相关资源、对您账号采取操作限制/账号冻结等措施）。",
    "k_da459249": "5.3.3 终止向您提供无极服务，终止协议（包括但不限于直接对您的全部服务进行下线并收回相关资源等）。",
    "k_67def981": "5.3.4 依法追究您的损失赔偿等其他责任。",
    "k_dea5268": "腾讯依据本协议采取相应措施（包括但不限于暂停服务、扣除费用、终止协议等），不视为腾讯违约，若因此给您造成损失（包括但不限于业务暂停、数据清空等）的，均由您自行承担。因您违反本协议约定产生的责任和后果由您自行承担，若给腾讯或第三方造成损失的，您应当予以赔偿。",
    "k_d2424662": "5.4 为合理保护您、您的用户及权利人等各方的利益，腾讯有权制定专门的侵权、投诉流程制度，您应当予以遵守。如果腾讯接到第三方对您的投诉或举报，腾讯有权向第三方披露您相关资料（如您的主体资料及您就投诉或举报提交的反通知书、相关证据等全部资料），要求您与投诉方进行协商（包括但不限于建立包含您、腾讯以及投诉方的三方邮件组，供您、投诉方直接沟通、相互举证等，下同），若您投诉或举报其他腾讯客户的，腾讯也有权向被投诉方披露您相关资料（如您的主体资料及您就投诉或举报提交的通知书、相关证据等全部资料），要求您与被投诉方进行协商，以便及时解决投诉、纠纷，保护各方合法权益，您应当予以配合，否则，可能会影响您继续使用无极服务，由此造成您或他方损失的，您自行承担。",
    "k_75422e93": "5.5 腾讯可将本协议部分或全部权利义务转让予第三方，但腾讯须提前7天书面通知您。为本款生效之需要，双方同意签订所有合理必要的文件及采取合理必要的措施。",
    "k_eb7ad248": "5.6 您同意腾讯有权使用您的名称、品牌、商标标识等作为商业案例进行宣传、展示。",
    "k_c866be6": "第六条 客户数据",
    "k_beb60101": "6.1 您保证，您存储、上传到无极服务中，或者利用无极服务以分析、分发等任何方式处理的数据，为您依法收集、获取或产生的数据，您不会也不曾以任何方式侵犯任何个人或实体的合法权利。",
    "k_deebda6e": "6.2 您保证其有权使用无极服务对前述数据进行存储、上传、分析和分发等任何处理，且前述处理活动均符合相关法律法规的要求，不存在任何违法、侵权或违反其与第三方的合同约定的情形，不会将数据用于违法违规目的。",
    "k_69c33684": "6.3 您有权自行使用无极服务对数据进行上传、分析、删除、更改等处理（具体以您使用的服务的服务规则为准），就数据的删除、更改等处理，您应谨慎操作并承担因该等操作所产生的后果。",
    "k_3f64463e": "6.4 除因您使用无极服务所需及法律法规另有规定外，未经您同意，腾讯不会接触或使用您的数据。",
    "k_9782a399": "6.5 您应根据自身需求自行对数据进行备份，腾讯仅依据相关法律法规要求或服务规则约定提供数据备份服务，腾讯仅在法定或约定提供的数据备份服务的范围内承担责任。",
    "k_288646c0": "6.6 因您的数据的产生、收集、处理、使用等任何相关事项存在违反法律法规等情况而造成的全部结果及责任均由您自行承担，并且，腾讯有权随时全部或部分终止向您提供无极服务。您因此遭受的一切损失或承担的一切责任和费用，由您自行承担。",
    "k_64bd03fc": "第七条 知识产权",
    "k_aeba8d9c": "7.1 双方各自享有的商标权、著作权或者其他知识产权，均仍归各方单独享有，并不会因为双方签订或者履行本协议而转归对方享有，或者转归双方共同享有。",
    "k_d0a3c9fb": "7.2 任何一方均应尊重相对方、第三方的知识产权，如有任何第三方就一方侵犯其知识产权等合法权益的原因向另一方提起诉讼、主张索赔的，责任方应当独立处理相关纠纷，赔偿另一方的直接经济损失，并使另一方免责。",
    "k_2b71b804": "第八条 保密信息",
    "k_6d305324": "8.1 双方为了本协议目的，已经或将会提供或透露某些保密信息。其中，披露保密信息的一方为“披露方”，而接受保密信息的一方为“接收方”。",
    "k_a1735f1b": "8.2 “保密信息”指由披露方持有的与其业务、经营、技术及权利等事项相关的，非公开的信息、资讯、数据、资料等，包括但不限于营业规划，商务资料，与技术有关之知识及信息、创意、设想、方案，提供的物品或厂商资料，用户信息，人事资料，商业计划，服务价格及折扣，财务状况等。",
    "k_8baef52c": "8.3 接收方从披露方所获悉的信息，如有标明或可合理认知为属于披露方的保密信息的，接收方须对披露方的保密信息保密，未经披露方书面同意，不得以任何方式披露给第三方或用于本协议以外目的。接收方应以对待其自身保密信息相同的注意程度（且不得低于合理审慎义务）对待披露方的保密信息。",
    "k_805782c1": "8.4 尽管有前述约定，符合下列情形之一的，相关信息不被视为保密信息：",
    "k_779dd886": "8.4.1 接收方在披露方向其披露之前已经通过合法的渠道或方式持有的信息。",
    "k_a1cf6221": "8.4.2 该信息已经属于公知领域，或该信息在非因接收方违反本协议的情况下而被公开。",
    "k_177b9a41": "8.4.3 接收方合法自其他有权披露资料的第三方处知悉且不负有保密义务的信息。",
    "k_4bbc5525": "8.4.4 由接收方不使用或不参考任何披露方的保密信息而独立获得或开发的。",
    "k_7b2cad83": "8.5 如果接收方基于法律法规或监管机关的要求，需要依法披露披露方的保密信息的，不视为违反本协议，但接收方应当在法律许可的范围内尽快通知披露方，同时，接收方应当努力帮助披露方有效限制该保密信息的披露范围，保护披露方合法权益。",
    "k_65fa3d7c": "8.6 双方保密义务在本协议有效期限内及期限届满后持续有效，直至相关信息不再具有保密意义。",
    "k_eaa040b9": "8.7 一旦发生保密信息泄露事件，双方应合作采取一切合理措施避免或者减轻损害后果的产生；如因接收方违反保密义务给披露方造成损失的，接收方应赔偿因此给披露方造成的直接经济损失。",
    "k_ccb15488": "第九条 出口管制与制裁法律合规",
    "k_3b4d3cbc": "各方承诺遵守所有适用的经济与贸易制裁以及出口管制法律法规，包括所有由联合国安全理事会、中国、美国及任何其他国家所制定并执行的制裁决议、法律与法规以及出口管制法律与法规（在前述文件适用于该方的范围内）（下称“适用出口管制法律”）。您承诺不会将腾讯提供的产品或服务用于适用出口管制法律所禁止的用途。非经相关主管机关许可，您及您授权使用腾讯提供的产品或服务的个人或实体不会通过腾讯提供的产品或服务向所适用出口管制法律所制裁或指定的个人或实体提供受控的技术、软件或服务，或以任何方式使得腾讯违反适用出口管制法律。",
    "k_2953b7d4": "第十条 责任限制",
    "k_7379c473": "10.1 您理解并同意，在使用无极服务的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，腾讯应及时与相关单位配合进行修复，但是由此给您造成的损失腾讯将予以免责。",
    "k_823578e5": "10.1.1 不可抗力，包括但不限于自然灾害、政府行为、法律法规颁布调整、罢工（任一方内部劳资纠纷除外）、动乱等不能预见、不能避免并不能克服的客观情况。",
    "k_aecfa375": "10.1.2 基础运营商原因，包括但不限于电信部门技术调整、电信/电力线路被他人破坏、电信/电力部门对电信网络/电力资源进行安装、改造、维护。",
    "k_9e6217d5": "10.1.3 网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏。",
    "k_245d2ed": "10.1.4 您通过非腾讯授权的方式使用无极服务，您操作不当或您的电脑软件、系统、硬件和通信线路出现故障。",
    "k_7762bf35": "10.1.5 其他非腾讯过错、腾讯无法控制或合理预见的情形。",
    "k_b4cb95e": "10.2 因不可抗力、基础运营商原因、网络安全事故或其他超出当事人可合理掌控范围的事件，造成本协议迟延履行或任何一方违约，双方均无需承担违约责任。但是，受影响一方应尽可能及时通知另一方。如前述事件妨碍协议履行达30天以上的，任一方可提前15天书面通知对方终止协议。因本条款终止协议的，任何一方均无须承担违约责任。",
    "k_f239d0b0": "10.3 您理解并同意，腾讯的服务是按照现有技术和条件所能达到的现状提供的。腾讯将尽最大努力确保服务的连贯性和安全性，但腾讯不能保证其所提供的服务毫无瑕疵，因此，即使腾讯提供的服务存在瑕疵，但若上述瑕疵是当时行业技术水平所无法避免的，其将不视为腾讯违约，腾讯也无需承担任何责任，双方应友好协作共同解决问题。",
    "k_2513d3f3": "10.4 于任何情形下，任一方均不对另一方之任何间接的、偶然的、特殊的或惩罚性的损害和损失（如利润损失、机会损失、向第三方支付的费用、声誉/商誉损失或损害等）承担责任，无论基于合同、保证、侵权或任何其他责任理论，不论任一方是否知道或应当知道上述损失或损害的可能性。",
    "k_a808f55d": "10.5 于任何情形下，腾讯基于本协议务向您所承担的赔偿责任（无论基于合同、侵权或任何其他责任理论）的总额，不超过腾讯就您使用无极服务所获的的直接经济利益。若本条款与双方其他约定或腾讯服务规则冲突或不一致的，以本条约定为准。",
    "k_c7c69c88": "第十一条 通知和送达",
    "k_38d28f81": "11.1 您应当保证和维持客户资料（包括但不限于电话号码、电子邮箱等联系方式）的有效性，客户资料若存在虚假、无效等任何可能导致您无法及时获悉业务通知、服务提示、客户服务、技术支持、纠纷协调、违规处罚等信息的，由您自行承担相应责任。",
    "k_ac6e8ad7": "11.2 您应当根据腾讯官网公布的腾讯的联系方式向腾讯发送通知，双方另有约定除外。",
    "k_51e21683": "11.3 腾讯可通过网页公告、系统通知、站内信、电子邮件、手机短信、即时通讯工具、函件等方式中的一种或多种向您发送与无极服务有关的业务通知、服务提示、验证消息、营销信息等各种信息（包括但不限于更新后的服务规则、服务升级、机房裁撤、广告等）。前述信息在以下情况下视为已送达：",
    "k_fa51c06": "11.3.1 交专人递送的，在收件人签收时视为已送达。",
    "k_7213a71f": "11.3.2 以网页公告等形式公布的，一经公布即生效（另有说明除外）。",
    "k_f84460fc": "11.3.3 以电子形式（包括系统通知、站内信、电子邮件、手机短信、即时通讯工具等）发送的，在发送成功后视为已送达。",
    "k_162dd6c": "11.3.4 以邮资预付的快递公司递送或以挂号信递送的，以投邮后的第3个自然日视为已送达。",
    "k_31e23868": "如果送达时间为法定节假日的，则以送达后首个工作日为送达日。",
    "k_7d189ec8": "第十二条 法律适用及争议解决",
    "k_a51110ab": "12.1 本协议的签订地为广东省深圳市南山区。",
    "k_d7b8f4dd": "12.2 本协议的成立、生效、履行、解释及纠纷解决等，均适用中国大陆法律法规（不包括冲突法）。",
    "k_55bb4942": "12.3 因本协议产生之争议，双方应首先协商解决；双方未能协商解决的，任何一方均应将争议提交本协议签订地有管辖权的人民法院裁决。双方无争议的部分，应当继续履行。",
    "k_f2237fdc": "第十三条 其他",
    "k_7ba06267": "13.1 除非另有说明，本协议正文及其附件中所有的“天”均为自然日，结算货币均为人民币。",
    "k_51690d7c": "13.2 本协议的拟定、解释均以中文为准。除双方另有约定外，任何有关本协议的翻译不得作为解释本协议或判定双方当事人意图之依据。",
    "k_69476c21": "13.3 服务规则为本协议的重要组成部分，与本协议正文具有同等法律效力，您应当予以遵守。",
    "k_c29f045b": "已注册 即将自动登录",
    "k_1515ae02": "已关闭注册",
    "k_bef7d5f": "用户ID",
    "k_7500f155": "中文名",
    "k_c26416e6": "申请说明",
    "k_8b554446": "您已发送过注册申请 确认覆盖上一次的注册申请吗",
    "k_132f0c77": "再次申请",
    "k_9fc34063": "立即注册",
    "k_e9657c": "你的注册请求{arg_0}",
    "k_f7508b44": "刷新",
    "k_4cfab1e9": "您上一次的注册请求：",
    "k_d7ed9716": "已通过",
    "k_817f09da": "审核中",
    "k_ff804007": "被拒绝",
    "k_b7477855": "已被拉黑，不可再次申请",
    "k_768b524e": "申请用户id",
    "k_3c696351": "申请备注",
    "k_f9ced745": "审批备注",
    "k_25876f81": "上次填写：{arg_0}",
    "k_57cb83f1": "加载失败：{arg_0}",
    "k_940a8efb": "字母开头，可含数字",
    "k_6d545e06": "请输入中文名",
    "k_825cb345": "请输入申请说明",
    "k_fb270f9b": "登录信息获取失败：{arg_0}",
    "k_71b097ce": "用户ID必填",
    "k_8749ef56": "请提供有效的用户ID，由字母、数字和下划线组成，其中第一个字符是字母"
};
